import React, { useEffect } from 'react'
import getUnicodeFlagIcon from 'country-flag-icons/unicode'

import { getCountryNameByCode } from '@fourthwall/utils/dist/inputs'

import * as S from './styled'

type CountryFlagProps = {
  countryCode: string | undefined
  size?: number
  withLabel?: boolean
}

export const CountryFlag = ({ countryCode, size = 18, withLabel = true }: CountryFlagProps) => {
  const Flag = countryCode
    ? () => <>{getUnicodeFlagIcon(countryCode)}</>
    : () => <S.UndefinedFlag $size={size}>?</S.UndefinedFlag>
  const countryName = countryCode ? getCountryNameByCode(countryCode) : 'Unidentified'

  useEffect(() => {
    import('country-flag-emoji-polyfill').then((module) => {
      module.polyfillCountryFlagEmojis()
    })
  }, [])

  return (
    <S.Container>
      <S.Flag $size={size}>
        <Flag />
      </S.Flag>
      {withLabel && countryName && <S.Label>{countryName}</S.Label>}
    </S.Container>
  )
}
